<template>
  <div class="m-card">
    <!-- <div class="header"><h2>Vibration Sensor Graph</h2></div> -->
    <div class="content">
      <StockChart :chart="optionChart" v-if="delay == 1" />
    </div>
  </div>
</template>

<script>
import StockChart from "@/components/HighChart/StockChart.vue";
export default {
  components: { StockChart },
  props:{
    dataVibration:Object,
  },
  data() {
    return {
      delay: 0,
      optionChart: {
        chart: {
          backgroundColor: "transparent",
        },
        // rangeSelector: {
        //   selected: 1,
        // },
        rangeSelector: {
            buttons: [{
                type: 'hour',
                count: 3,
                text: '3h'
            },
            {
                type: 'hour',
                count: 6,
                text: '6h'
            },
            {
                type: 'hour',
                count: 12,
                text: '12h'
            },{
                type: 'day',
                count: 1,
                text: '1D'
            }, {
                type: 'all',
                count: 1,
                text: 'All'
            }],
            selected: 1,
            // inputEnabled: false
        },
        colors: ['#cc7400', '#00cc7e', '#da2acb',],
        title: {
          text: "Vibration Sensor Graph",
          align: "left",
          style: {
            color: "var(--text-color-2)",
            fontSize: "18px",
            "font-weight": "900",
          },
        },

        series: [],
      },
      dataA: [],
    };
  },
  mounted() {
    // let dataA = [];
    // let dataB = [];
    // let dataC = [];
    // let date = new Date().getTime();
    // for (let i = 0; i < 1000; i++) {
    //   //   const element = this.dataA[i];
    //   // dataA.push(element)
    //   dataA.push([date, Number((Math.random() * (1 - -1) + -1).toFixed(2))]);
    //   dataB.push([date, Number((Math.random() * (1 - -1) + -1.5).toFixed(2))]);
    //   dataC.push([date, Number((Math.random() * (1 - -1) + -0.5).toFixed(2))]);
    //   date = date - (1000*60*30);
    // }
    // dataA.reverse()
    // dataB.reverse()
    // dataC.reverse()
    this.optionChart.series = [
      {
        name: "X-axis",
        data: this.dataVibration.x,
        tooltip: {
          valueDecimals: 2,
        },
      },
      {
        name: "Y-axis",
        data: this.dataVibration.y,
        tooltip: {
          valueDecimals: 2,
        },
      },
      {
        name: "Z-axis",
        data: this.dataVibration.z,
        tooltip: {
          valueDecimals: 2,
        },
      },
    ];
    console.log(this.optionChart);
    this.delay = 1;
  },
};
</script>

<style lang="scss" scoped>
</style>